import React                          from 'react';
import { Prompt }                     from 'react-router-dom';
import { Observe }                    from 'rewire-core';
import { WithStyle }                  from 'rewire-ui';
import Typography                     from '@material-ui/core/Typography';
import Divider                        from '@material-ui/core/Divider';
import { Theme }                      from '@material-ui/core/styles';
import TimecardTestExpectedResults    from './TimecardTestExpectedResults';
import TimecardTestSummaryDailyRollup from './TimecardTestSummaryDailyRollup';
import timecardTestSummaryModel       from './TimecardTestSummaryModel';
import { withStyles }                 from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative'
  },
  title: {
    marginBottom: '15px',
  },
  scrollablePart: {
    overflow: 'auto'
  },
  employeeTitle: {
    marginBottom: '2px',
  },
  testEffective: {
    marginBottom: '6px',
  },
  infoColumn: {
    display: 'inline-block',
    width: '95px',
  },
  divider: {
    margin: '15px 0px',
  },
});

interface ITimecardTestSummaryViewProps {
  className?: string;
}

type TimecardTestSummaryViewProps = WithStyle<ReturnType<typeof styles>, ITimecardTestSummaryViewProps>;

class TimecardTestSummaryView extends React.PureComponent<TimecardTestSummaryViewProps> {
  constructor(props: TimecardTestSummaryViewProps) {
    super(props);
  }

  componentWillUnmount() {
    timecardTestSummaryModel.reset();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe render={() => {
          const test = timecardTestSummaryModel.test?.name;
          return <Prompt when={timecardTestSummaryModel.hasChanges} message={_location => `There are unsaved changes for ${test}.\nDo you wish to return and save your changes?`} />;
        }} />

        <Observe render={() => {
          if (timecardTestSummaryModel.test) {
            return (
              < >
                <div className={classes.title}>
                  <Typography variant='h4' className={classes.employeeTitle}>{timecardTestSummaryModel.test.employee.name}</Typography>
                  <Typography variant='body2' className={classes.testEffective}><strong>{`${timecardTestSummaryModel.test.effective.startAsString()} to ${timecardTestSummaryModel.test.effective.endAsString() || '-'}`}</strong></Typography>
                  <Typography variant='body2'><span><span className={classes.infoColumn}><strong>Last Ran: </strong></span>{timecardTestSummaryModel.test.lastRan.toDateString()}</span></Typography>
                  <Typography variant='body2'><span><span className={classes.infoColumn}><strong>Last Edited By: </strong></span>{timecardTestSummaryModel.test.lastEditedBy}</span></Typography>
                </div>
                <div className={classes.scrollablePart}>
                  <TimecardTestExpectedResults />
                  <Divider className={classes.divider} />
                  <TimecardTestSummaryDailyRollup />
                </div>
              </>
            );
          } else {
            return null;
          }
        }} />
      </div>
    );
  }
}

export default withStyles<ITimecardTestSummaryViewProps>(styles, TimecardTestSummaryView);
